import * as Yup from 'yup';

import { addSchemaValidationSchema } from 'src/app/graph/subgraphsLayout/subgraphsPage/addSubgraphModal/shared';

export const VARIANT_NAME_MAX_CHAR = 14;

const variantNameErrorMessages = {
  required: 'Please provide a name for your variant.',
  start: 'Variant name must start with a letter.',
  max: `Variant must be at most ${VARIANT_NAME_MAX_CHAR} characters.`,
  min: 'Variant must be at least 2 characters.',
  acceptedChars: 'Variant name may only contain letters, numbers and dashes.',
  doubleDash: 'Variant name may not contain two consecutive dashes.',
};

const variantNameSchema = Yup.string()
  .required(variantNameErrorMessages.required)
  .min(2, variantNameErrorMessages.min)
  .max(VARIANT_NAME_MAX_CHAR, variantNameErrorMessages.max)
  .matches(/^[a-zA-Z0-9]/, variantNameErrorMessages.start)
  .matches(/^[a-zA-Z0-9-]*$/, variantNameErrorMessages.acceptedChars)
  .matches(/^(?!.*\-\-)[a-zA-Z0-9-]*$/, variantNameErrorMessages.doubleDash);

export enum AddVariantWizardStep {
  NameVariant = 'Name Variant',
  AddSchema = 'Add Schema',
  AddSubgraph = 'Add Subgraph',
}

export const AddVariantWizardSteps = (hasManagedSubgraphs: boolean) => [
  AddVariantWizardStep.NameVariant,
  hasManagedSubgraphs
    ? AddVariantWizardStep.AddSubgraph
    : AddVariantWizardStep.AddSchema,
];

export const addVariantWizardValidationSchema = addSchemaValidationSchema.shape(
  {
    variantName: variantNameSchema,
  },
);

export const addVariantWizardErrorMessages = {
  variantName: variantNameErrorMessages,
};

export type AddVariantWizardFields = Yup.InferType<
  typeof addVariantWizardValidationSchema
>;

export type AddSubgraphFormFields = Yup.InferType<
  typeof addSchemaValidationSchema
>;
